// src/redux/slices/CommissionSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Change this to your actual backend API base URL
const API_BASE_URL = 'http://localhost:5000';

export const fetchDropdownData = createAsyncThunk(
  'commission/fetchDropdownData',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/commission/dropdowns`);
      if (!res.ok) {
        const text = await res.text();
        return rejectWithValue(`Server error: ${text}`);
      }
      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        return rejectWithValue(`Expected JSON response but got: ${contentType}`);
      }
      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const submitCommissionForm = createAsyncThunk(
  'commission/submitCommissionForm',
  async (formData, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/commission/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!res.ok) {
        const text = await res.text();
        return rejectWithValue(`Submit failed: ${text}`);
      }
      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        return rejectWithValue(`Expected JSON response but got: ${contentType}`);
      }
      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const commissionSlice = createSlice({
  name: 'commission',
  initialState: {
    schemeTypes: [],
    schemes: [],
    commissionTypes: [],
    commissionModes: [],
    ranks: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetCommissionState: (state) => {
      state.error = null;
      state.success = false;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDropdownData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDropdownData.fulfilled, (state, action) => {
        state.loading = false;
        state.schemeTypes = action.payload.schemeTypes || [];
        state.schemes = action.payload.schemes || [];
        state.commissionTypes = action.payload.commissionTypes || [];
        state.commissionModes = action.payload.commissionModes || [];
        state.ranks = action.payload.ranks || [];
      })
      .addCase(fetchDropdownData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(submitCommissionForm.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(submitCommissionForm.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(submitCommissionForm.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.success = false;
      });
  }
});

export const { resetCommissionState } = commissionSlice.actions;

export default commissionSlice.reducer;
